<template>
	<div
		:class="[
			'inp_field',
			{
				has_focus: hasFocus,
				has_value: hasValue,
				has_clear: clearable,
			},
		]"
	>
		<input
			ref="inputRef"
			:class="['inp', formClass, { inp_error: error, w100p: justify }]"
			v-bind="attrs"
			v-on="listeners"
		/>
		<button
			type="button"
			class="btn_reset"
			v-if="!readonly && !disabled && clearable && hasValue"
			@click="clear"
			tabindex="-1"
		>
			<span class="txt_hidden">값 지우기</span>
		</button>
	</div>
</template>

<script>
export default {
	model: {
		prop: 'value',
		event: 'update',
	},

	props: {
		error: Boolean,
		clearable: Boolean,
		value: String,
		justify: Boolean,
		onlyNumber: Boolean,
		defaultValue: String,
		disabled: Boolean,
		readonly: Boolean,
		formClass: String,
		maxByte: Number,
		onlyTxtNotBlank: Boolean,
		rules: Array,
	},

	data() {
		return {
			hasFocus: false,
			localValue: this.value || this.defaultValue,
		};
	},

	computed: {
		attrs() {
			return {
				...this.$attrs,
				value: this.localValue,
				disabled: this.disabled,
				readonly: this.readonly,
				type: this.$attrs.type ?? 'text',
			};
		},
		listeners() {
			return {
				...this.$listeners,
				input: this.onInput,
				focus: this.onFocus,
				blur: this.onBlur,
			};
		},
		input() {
			return this.$refs.inputRef;
		},
		hasValue() {
			return !!this.localValue;
		},

		/**
		 * 필요 정규식 추가 할 것
		 */
		validRule() {
			return {
				onlyNumber: '0-9', // 숫자만
				onlyKorEng: '가-힣a-zA-Zㄱ-ㅎ', // 한글(모음제외),영어만
			};
		},
		regex() {
			if (!this.rules) {
				return;
			}
			const regex = this.rules.map(rule => this.validRule[rule]).join('');
			return new RegExp(`[^${regex}]+`, 'g'); // 정규식 수정
		},
	},

	methods: {
		clear() {
			this.input.focus();
			this.$nextTick(() => {
				this.input.value = '';
				this.localValue = this.input.value;
			});
		},

		onInput(e) {
			const element = e.target;

			if (this.onlyTxtNotBlank) {
				element.value = element.value.replace(/\s/gi, ''); // 공백 막기
			}

			/**
			 * 기존코드 밑에 추후 이프문 블록처럼 변경 할 것
			 */
			if (this.onlyNumber) {
				const { selectionStart } = element;
				const value = element.value || '';
				const filteredValue = value.replace(/[^0-9]/g, '');
				if (value !== filteredValue) {
					element.value = filteredValue;
					element.setSelectionRange(selectionStart - 1, selectionStart - 1);
				}
			}

			if (this.regex) {
				const { selectionStart } = element;
				const value = element.value || '';
				const filteredValue = value.replace(this.regex, ''); // 정규식 적용
				if (value !== filteredValue) {
					element.value = filteredValue;
					element.setSelectionRange(selectionStart - 1, selectionStart - 1);
				}
			}

			if (this.maxByte) {
				const { selectionStart } = element;
				const value = element.value || '';
				const beforeValue = value.slice(0, -1);
				const getByteLengthOfString = (s, b, i, c) => {
					for (b = i = 0; (c = s.charCodeAt(i++)); b += c >> 11 ? 3 : c >> 7 ? 2 : 1);
					return b;
				};
				if (getByteLengthOfString(value) > this.maxByte) {
					element.value = beforeValue;
					element.setSelectionRange(selectionStart - 1, selectionStart - 1);
				}
			}

			this.$emit('input', e);
			this.localValue = element.value;
		},

		onFocus(e) {
			this.hasFocus = true;
			this.$emit('focus', e);
		},

		onBlur(e) {
			this.hasFocus = false;
			this.$emit('blur', e);
		},
	},

	watch: {
		value() {
			this.localValue = this.value;
		},
		localValue() {
			this.$emit('update', this.localValue);
		},
	},
};
</script>

<style></style>
